import { render, staticRenderFns } from "./SubscriptionIndex.vue?vue&type=template&id=53d348df&"
import script from "./SubscriptionIndex.vue?vue&type=script&lang=js&"
export * from "./SubscriptionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports